import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useActions, useSelector } from 'statux'

import DashboardEbpcAssignmentsTable
    from './DashboardEbpcAssignmentsTable/DashboardEbpcAssignmentsTable'

import DashboardEbpcAssignmentsFeedbackForm
    from './DashboardEbpcAssignmentsFeedbackForm/DashboardEbpcAssignmentsFeedbackForm'

import { getCssVar } from '../../../utils/css'
import { scrollTo } from '../../../utils/dom'
import { graphqlClient, gql } from '../../../utils/gql'

import authProvider from '../../../utils/auth-provider'

export default function DashboardEbpcAssignments (props = {
    heading: null,
    submitSuccessModal: null
}) {
    const role = authProvider.getDefaultRole()

    const isMember = role === 'member'

    const isEbpcJudge = role === 'ebpc_judge'

    const history = useHistory()

    const [{
        complete,
        submitted
    }, setSubmitState] = useState({
        complete: null,
        submitted: null
    })

    const setModal = useActions('modal')

    const [successModal, setSuccessModal] = useState()

    const {
        ebpcContest,
        ebpcApplicationsOpen,
        ebpcAssignmentsEndDateStr,
        ebpcAssignmentsOpen,
        ebpcFinalsOpen
    } = useSelector()

    const onSubmit = async (e) => {
        const mutation = await graphqlClient
            .request(gql`
                mutation {
                    update_ebpc_assignments (
                        where: {
                            ebpc_judge_id: { _eq: "${authProvider.getIdentity().id}" },
                            ebpc_finals: { _eq: ${ebpcFinalsOpen} }
                        },
                        _set: {
                            submitted_at: "${(new Date()).toISOString()}"
                        }
                    ) {
                        returning {
                            submitted_at
                        }
                    }
                }
            `)
            .catch((err) => {
                console.warn(err)
                return null
            })

        if (!mutation)
            return

        scrollTo([0, parseFloat(getCssVar('--sticky-nav-offset')) || 0], {
            cancelOnUserAction: false
        }).then(() => {
            setSubmitState({
                complete: true,
                submitted: true
            })

            const { richText } = props.submitSuccessModal || {}

            if (richText)
                delete (props.submitSuccessModal || {}).richText

            setSuccessModal(Object.assign({
                className: 'modal-ebpc-assignment',
                iconBackground: getCssVar('--aqua'),
                heading: 'Thanks for submitting your ratings!',
                component: (
                    <DashboardEbpcAssignmentsFeedbackForm
                        richText={richText}
                    />
                )
            }, props.submitSuccessModal || {}))
        })
    }

    useEffect(async () => {
        let redirect = '/dashboard'

        if (isMember
                && ebpcApplicationsOpen)
            redirect += '/ebpc/application'

        if (!ebpcAssignmentsOpen
                || !isEbpcJudge)
            return history.push(redirect)

        const query = await graphqlClient
            .request(gql`
                query {
                    ebpc_assignments (
                        where: {
                            ebpc_judge_id: {
                                _eq: "${authProvider.getIdentity().id}"
                            },
                            ebpc_application: {
                                ebpc_contest_id: {
                                    _eq: ${ebpcContest.id}
                                },
                                submitted_at: {
                                    _is_null: false
                                }
                            },
                            recused_at: {
                                _is_null: true
                            },
                            ebpc_finals: {
                                _eq: ${ebpcFinalsOpen}
                            }
                        },
                        order_by: [
                            { ranking: asc },
                            { rating: desc_nulls_last },
                            { ebpc_application_id: asc }
                        ]
                    ) {
                        invest
                        ranking
                        rating
                        submitted_at
                        ebpc_judge_id
                        ebpc_application_id
                        ebpc_application {
                            id
                            data
                            venture: data(path: "aboutYourVenture.ventureName")
                            profile {
                                company
                                user {
                                    id
                                }
                            }
                        }
                        ebpc_ratings (where: {
                            ${ebpcFinalsOpen
                                ? gql`ebpc_finals: { _eq: true }`
                                : ''}
                        }) {
                            type
                            rating
                        }
                    }

                    ebpc_ratings_types_aggregate {
                        aggregate {
                            count
                        }
                    }
                }
            `)
            .then(obj => obj.ebpc_assignments
                .map(_obj => {
                    const ratingsTypesCount = obj.ebpc_ratings_types_aggregate
                        .aggregate
                        .count || 0

                    _obj.status = 'Not started'
                    _obj.statusType = null

                    if (_obj.ebpc_ratings.length
                            || _obj.rating
                            || _obj.invest !== null) {
                        _obj.status = 'In progress'
                        _obj.statusType = 'warning'
                    }

                    if (ratingsTypesCount === _obj.ebpc_ratings.length
                            && _obj.rating
                            && _obj.invest !== null) {
                        _obj.status = 'Completed'
                        _obj.statusType = 'success'
                    }

                    _obj.plan = _obj.ebpc_application.id

                    _obj.venture = _obj.ebpc_application.venture
                        || _obj.ebpc_application.profile.company

                    _obj.applicant = _obj.ebpc_application.profile.user

                    return _obj
                }))
            .catch((err) => {
                console.warn(err)
                return []
            })

        const isSubmitted = !query
            .filter(obj => !obj.submitted_at)
            .length

        setSubmitState({
            complete: !query
                .filter(obj => obj.statusType !== 'success')
                .length,
            submitted: isSubmitted
        })

        if (isSubmitted)
            history.push(redirect)
    }, [])

    useEffect(() => {
        if (successModal)
            setModal(successModal)
    }, [successModal])

    return (
        <div
            className="dashboard-ebpc-assignments pad-3-t pad-4-b pad-4-t-lg-up"
        >
            <div className="container">
                <div className="row-condensed flex-jusitify-content-between margin-3-b">
                    <div className="col-12">
                        <Link
                            to="/dashboard"
                            className="body-4 display-inline-flex"
                            style={{
                                color: getCssVar('--slate'),
                                marginBottom: '5px',
                                lineHeight: 1.1,
                                overflow: 'hidden'
                            }}
                        >
                            <svg
                                className="icon-chevron-left flex-none"
                                width="18"
                                height="18"
                                style={{ margin: '-2px 2px 0 -5px' }}
                            >
                                <use xlinkHref="#icon-chevron-left" />
                            </svg>
                            <span>
                                <span className="display-none-sm-down">Go back </span>
                                <span className="text-transform-capitalize display-none-sm-up">back </span>
                                to EBPC judging portal
                            </span>
                        </Link>
                    </div>
                    <div className="col-12 col-7-lg-up">
                        <h1 className="heading-2 display-flex">
                            {props.heading || 'EBPC Assignments'}
                        </h1>
                    </div>
                </div>

                <div className="row-condensed">
                    <section className="col-12 col-8-xl-up margin-1-b-xl-down">
                        <div className="dashboard-ebpc-applications card card-offscreen-x-lg-down">
                            <DashboardEbpcAssignmentsTable
                                ventureColText="Venture name"
                                rankingColText="Your overall rating"
                                rankingBtnLink
                                draggable
                            />
                        </div>
                    </section>
                    <aside className="col">
                        <div className="card card-offscreen-x-lg-down">
                            <p className="body-4 margin-b">
                                Please review your rankings before submitting.
                                Drag and drop ventures to change their rankings.
                                1 is the highest ranking.
                            </p>
                            {ebpcAssignmentsEndDateStr
                                && (
                                    <p className="body-4 margin-b">
                                        Please complete all reviews by {
                                            ebpcAssignmentsEndDateStr
                                        }.
                                    </p>)}
                            <p className="body-4 margin-b">
                                Once final ratings and rankings are submitted, they cannot be changed.
                            </p>
                            {complete !== null
                                && (
                                    <button
                                        className="btn btn-secondary"
                                        disabled={!complete || submitted}
                                        onClick={onSubmit}
                                        style={{
                                            paddingTop: 15,
                                            paddingBottom: 15
                                        }}
                                    >
                                        Submit final ratings
                                    </button>)}
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    )
}
